import { apiBaseUrl } from "../data/artemulkContent";

export const toProxyUrl = (url) => {
  if (!url || typeof url !== "string") return "";

  // Eğer zaten proxy url ise, içindeki url parametresini çözüp tekrar sarmalamasını önle
  while (url.includes("/image-proxy") && url.includes("url=")) {
    try {
      const match = url.match(/[?&]url=([^&]+)/);
      if (match) {
        url = decodeURIComponent(match[1]);
      } else {
        break;
      }
    } catch {
      break;
    }
  }

  if (!url.startsWith("http://") && !url.startsWith("https://")) {
    url = `https://imaj.emlakjet.com/original${url.startsWith("/") ? "" : "/"}${url}`;
  }

  if (url.includes("emlakjet.com")) {
    return `${apiBaseUrl}/image-proxy?url=${encodeURIComponent(url)}`;
  }
  return url;
};

/**
 * Office API kartı veya panel yanıtını Property sayfası formatına çevirir.
 */
const imageUrl = (path) => {
  if (!path) return "";
  let p = path;
  if (typeof p === "object") {
    p = p.url || p.originalImageUrl || p.src || "";
  }
  if (!p || typeof p !== "string") return "";
  return toProxyUrl(p);
};

const itemProperty = (key, tr, displayName) => {
  const prop = {
    key,
    value: { items: [{ name: { tr: String(tr) } }] },
  };
  if (displayName) prop.name = displayName;
  return prop;
};

const labelProperty = (key, tr, displayName) => {
  const prop = {
    key,
    value: { label: { tr: String(tr) } },
  };
  if (displayName) prop.name = displayName;
  return prop;
};

const quickInfoVal = (info) => {
  const v = info?.value;
  if (v != null && String(v).trim() !== "") return String(v);
  const n = info?.name;
  if (n != null && String(n).trim() !== "") return String(n);
  return "";
};

const listingDescription = (listing) =>
  listing.description ||
  listing.listingDescription ||
  listing.content ||
  listing.detail ||
  "";

export const normalizeListingDetail = (raw) => {
  if (!raw) return null;
  if (raw.result) {
    let rawImages = raw.result.images;
    if (!rawImages || !rawImages.length) {
      if (raw.result.imagesFullPath?.length) {
        rawImages = raw.result.imagesFullPath;
      } else if (raw.result.thumbnailOriginal) {
        rawImages = [raw.result.thumbnailOriginal];
      }
    }

    if (Array.isArray(rawImages)) {
      return {
        ...raw,
        result: {
          ...raw.result,
          images: rawImages.map((img) => ({
            ...(typeof img === "object" ? img : {}),
            originalImageUrl: toProxyUrl(
              typeof img === "object"
                ? img.originalImageUrl || img.url || img.src || ""
                : String(img)
            ),
          })),
        },
      };
    }
    return raw;
  }

  const listing = raw;
  let paths = listing.imagesFullPath?.length
    ? listing.imagesFullPath
    : listing.images || [];

  if ((!paths || paths.length === 0) && listing.thumbnailOriginal) {
    paths = [listing.thumbnailOriginal];
  }

  const images = (paths || [])
    .map((path) => ({
      originalImageUrl: imageUrl(path),
    }))
    .filter((img) => Boolean(img.originalImageUrl));

  const desc = listingDescription(listing);

  const properties = [
    labelProperty("title", listing.title || ""),
    labelProperty("description", desc || ""),
    labelProperty(
      "price",
      listing.priceDetail?.price ?? listing.price ?? ""
    ),
  ];

  if (listing.squareMeter) {
    properties.push(labelProperty("square", listing.squareMeter));
  }
  if (listing.roomCountName) {
    properties.push(itemProperty("room_count", listing.roomCountName));
  }

  const itemKeys = new Set([
    "heating_type",
    "bath_count",
    "furniture_status",
    "usability",
    "build_age",
    "deed_status",
    "suitability_for_credit",
    "trade",
    "flat_for_construction",
    "room_count",
    "floor_number",
    "floor_count",
    "net_square",
    "gross_square",
  ]);

  const filledKeys = new Set(properties.map((p) => p.key));

  (listing.quickInfos || []).forEach((info) => {
    const key = info?.key;
    const val = quickInfoVal(info);
    if (!key || val === "" || filledKeys.has(key)) return;
    if (key === "room_count" && listing.roomCountName) return;

    const prop = itemKeys.has(key)
      ? itemProperty(key, val, info?.name)
      : labelProperty(key, val, info?.name);
    properties.push(prop);
    filledKeys.add(key);
  });

  if (listing.floorName && !filledKeys.has("floor_number")) {
    properties.push(
      itemProperty("floor_number", `${listing.floorName}. Kat`)
    );
  }

  const loc = listing.location || {};

  return {
    result: {
      id: listing.id,
      images,
      createdAt: listing.createdAt || listing.publishDate || null,
      location: {
        city: loc.city?.name ?? loc.city ?? "",
        district: loc.district?.name ?? loc.district ?? "",
        town: loc.town?.name ?? loc.town ?? "",
      },
      metadata: {
        category: { name: { tr: listing.categoryTypeName || "" } },
        tradeType: { name: { tr: listing.tradeTypeName || "" } },
        estateType: { name: { tr: listing.estateTypeName || "" } },
      },
      properties,
    },
  };
};
